import React, { useRef, useEffect, useLayoutEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useRouteMatch } from 'react-router-dom';
import { getNavbarHeight, getViewportDimensions } from '../../../../models/Utils';
import { innovationMediaTypes } from '../../../../models/Models';

import './DetailExpander.scss';

const DetailExpander = React.forwardRef(({ data, isActive, icon, label, activityHandler, wrapperParams, closeParams, onMobile }, theRef) => {
  const mediaPath = useSelector(state => state.config.basePath + state.config.apiMediaPath);
  const [mobileContentStyle, setMobileContentStyle] = useState({ display: 'none' });
  const refInner = useRef(null);
  const refWrapperParams = useRef(null);
  const refCloseParams = useRef(null);
  const titleRef = useRef(null);

  const adjustDescription = () => {
    const desc = data.Description;
    const url = data.DescriptionLink;

    if (!url) return desc.replace('<b>', '').replace('</b>', '');

    const firstSplit = desc.split('<b>');
    if (firstSplit.length < 2) return firstSplit.join('');

    const fullSplit = [firstSplit[0], ...firstSplit[1].split('</b>')];
    if (fullSplit.length < 3) return fullSplit.join('');

    return <>{fullSplit[0]}<button tabIndex={-1} className="innovation-de-desc-link" target="_blank" href={url}>{fullSplit[1]}</button>{fullSplit[2]}</>;
  };

  const getMedia = () => {
    if (data && data.MediaType === innovationMediaTypes.ImageOrGif) {
      return <img className="innovation-de-media-image" src={mediaPath + data?.ImageMedia?.Image} alt={data?.ImageMedia?.AltText} />
    }

    if (data && data.MediaType === innovationMediaTypes.Video) {
      return (
        isActive ?
        <div className="innovation-de-media-video">
          <ReactPlayer
            className="innovation-de-player"
            url={data.VideoMedia.URL}
            width='100%'
            height='100%'
            muted={false}
            loop={false}
            playing={false}
            controls={true}
            playsinline={true}
            volume={1}
            config={{
              youtube: data.VideoMedia.URL.indexOf("youtube.com") < 0 ? null : {
                playerVars: {
                  autoplay: 1,
                  showinfo: 1,
                  playsinline: 1,
                  modestbranding: 1
                },
              }
            }}
          />
        </div>
        :null
      );
    }

    return null;
  };

  const calculateMobileContentStyle = () => {
    if (!refWrapperParams.current || !refCloseParams.current || !refInner.current) {
      setTimeout(() => {
        calculateMobileContentStyle();
      }, 1);
    } else {
      const wrapperRect = refWrapperParams.current;
      const closeRect = refCloseParams.current;
      const innerRect = refInner.current.getBoundingClientRect();
      const left = wrapperRect.left - innerRect.left;
      const width = wrapperRect.width;
      const top = closeRect.top - innerRect.top + closeRect.height + 40;
      setMobileContentStyle({
        top: `${top}px`,
        left: `${left}px`,
        width: `${width}px`
      });
    }
  };

  useEffect(() => {
    refWrapperParams.current = wrapperParams;
    refCloseParams.current = closeParams;
  }, [wrapperParams, closeParams]);

  const handleResize = () => {
    calculateMobileContentStyle();
    
  };

  useLayoutEffect(() => {
    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div 
      className={`innovation-detail-expander ${ isActive ? 'active' : '' }`}
      ref={theRef}
      aria-hidden={!isActive ? "true" : "false"}
    >
      <div className="innovation-de-inner" ref={refInner}>
        <div
          className="innovation-de-content"
          style={
            !onMobile
            ?
            null
            :
            mobileContentStyle
          }
        >
          <div className="innovation-de-content-inner">
            <h2 ref={titleRef} className="innovation-de-title">{data && data.Title}</h2>
            {getMedia()}
            <p className="innovation-de-description">{data && adjustDescription(data.Description)}</p>
          </div>  
        </div>
        <button
          tabIndex={isActive?-1:0}
          aria-hidden={isActive?true:false}
          aria-label={label}
          className={`innovation-de-nav-button ${icon} ${ isActive ? 'active' : '' }`}
          onClick={() => {
            activityHandler();
            titleRef.current.focus();
          }}
        >
          <div className="innovation-de-nav-overlay"/>
          <div aria-hidden={true} className='innovation-de-nav-label'>{label}</div>
        </button>
      </div>
    </div>
  );
});

export default DetailExpander;